interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
  };
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema, articleData }: SEOHeadProps) {
  const fullTitle = `${title} - 麻花影视`;
  const baseUrl = 'https://mahua.example.com';
  const canonical = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="麻花影视" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {articleData?.publishedTime && <meta property="article:published_time" content={articleData.publishedTime} />}
      {articleData?.modifiedTime && <meta property="article:modified_time" content={articleData.modifiedTime} />}
      {articleData?.author && <meta property="article:author" content={articleData.author} />}
      {schema && (
        Array.isArray(schema)
          ? schema.map((s, i) => <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>)
          : <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </>
  );
}